import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DestroyBase } from '../../../../shared/base-classes/destroy-component-base';
import { takeUntil } from 'rxjs';
import { SelfSignupService } from '../../services/self-signup.service';
import { AuthService } from '../../../auth/services/auth.service';
import { LoaderService } from '../../../../shared/services/loader/loader.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-org-onboarding-complete',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './org-onboarding-complete.component.html',
  styleUrl: './org-onboarding-complete.component.scss',
})
export class OrgOnboardingCompleteComponent
  extends DestroyBase
  implements OnInit
{
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private selfSignupService = inject(SelfSignupService);
  private authService = inject(AuthService);
  private loaderService = inject(LoaderService);

  isValid = false;
  errorMessage = '';
  isLoading = true;
  secretCode = '';

  ngOnInit(): void {
    this.secretCode = this.route.snapshot.queryParams['code'] || '';

    if (!this.secretCode) {
      this.errorMessage = 'Invalid or expired invitation link.';
      this.isLoading = false;
      return;
    }

    this.validateSecretCode();
  }

  private validateSecretCode(): void {
    this.selfSignupService
      .validateConnectionSecret(this.secretCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response.valid) {
            this.isValid = true;
            this.isLoading = false;
          } else {
            this.errorMessage = 'Invalid or expired invitation link.';
            this.isLoading = false;
          }
        },
        error: () => {
          this.errorMessage = 'Invalid or expired invitation link.';
          this.isLoading = false;
        },
      });
  }

  loginWithMicrosoft(): void {
    if (!this.secretCode) return;
    this.loaderService.show();
    this.authService
      .logInWithSecret(this.secretCode, environment.azureConnectionName)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  loginWithGoogle(): void {
    if (!this.secretCode) return;
    this.loaderService.show();
    this.authService
      .logInWithSecret(this.secretCode, 'google-oauth2')
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }
}
